export default __webpack_public_path__ + "media/images/solution_line-a4d917b9dcf75e52ca61f7621fd11250.png";